<template>
  <div>
    <audience-template-card-overview :template="template" />

    <v-sheet rounded class="py-2 px-6 mt-4">
      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Zdroj
          </p>
        </v-col>
        <v-col lg="12" class="pb-4">
          <v-select
            hide-details="auto"
            :items="pixels"
            item-text="name"
            item-value="id"
            outlined
            v-model="includedSource"
            return-object
            @input="isValid('includedSource')"
            :error-messages="getValidationsErrors('includedSource')"
          ></v-select>
        </v-col>
      </v-row>

      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Retence
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-text-field
            outlined
            hide-details="auto"
            suffix="dny/dnů"
            type="number"
            min="1"
            v-model="includedRetention"
            @input="isValid('includedRetention')"
            :error-messages="getValidationsErrors('includedRetention')"
          />
        </v-col>
      </v-row>

      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Stránka
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-text-field
            outlined
            hide-details
            placeholder="Zadejte děkovací stránku produktu"
            v-model="includedPage"
            @input="isValid('includedPage')"
            :error-messages="getValidationsErrors('includedPage')"
          />
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import AudienceTemplateCardOverview from "@/components/ui/AudienceTemplateCardOverview.vue"
import includedMixin from "./includedMixin"
import validation from "@/mixins/validation"
import { required } from "vuelidate/lib/validators"

export default {
  mixins: [includedMixin, validation],
  props: {
    template: {
      type: Object,
      required: true,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      validationMessages: {
        includedSource: {
          required: "Toto pole je povinné",
        },
        includedRetention: {
          required: "Toto pole je povinné",
        },
        includedPage: {
          required: "Toto pole je povinné",
        },
      },
    }
  },
  validations: {
    includedSource: {
      required,
    },
    includedRetention: {
      required,
    },
    includedPage: {
      required,
    },
  },
  components: {
    AudienceTemplateCardOverview,
  },
  computed: {
    ...get("pixels", ["pixels"]),
  },
  methods: {
    ...call("pixels", ["loadPixels"]),
  },
  mounted() {
    this.loadPixels()
  },
}
</script>
